(() => {
  if (customElements.get('di-product-description')) return;
  class ProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.tables = [];
      this.querySelectorAll('table').forEach(table => {
        let wrap = table.parentElement;
        if (!wrap.classList.contains('di-table-scroll')) {
          wrap = document.createElement('div');
          wrap.className = 'di-table-scroll';
          table.before(wrap);
          wrap.append(table);
          const hint = document.createElement('p');
          hint.className = 'di-table-hint';
          hint.textContent = this.dataset.tableHint;
          hint.hidden = true;
          wrap.before(hint);
        }
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', this.dataset.tableLabel);
        this.tables.push({ table, wrap, hint: wrap.previousElementSibling });
      });
      const update = () => this.tables.forEach(({ table, wrap, hint }) => {
        const overflow = table.scrollWidth > wrap.clientWidth + 1;
        wrap.tabIndex = overflow ? 0 : -1;
        hint.hidden = !overflow;
      });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(update);
        this.tables.forEach(({ wrap, table }) => { this.observer.observe(wrap); this.observer.observe(table); });
      }
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  }
  customElements.define('di-product-description', ProductDescription);
})();
